import api from '../api'

const baseUrl = '/BizSchool/api/Admin'

const dadbanFrequentlyAskedQuestionsProvider = {
  getQuestions(id) {
    return api.get(`${baseUrl}/PackageFrequentlyAskedQuestions/${id}`)
  },

  addFrequentlyAskedQuestions(params) {
    return api.post(`${baseUrl}/PackageFrequentlyAskedQuestions`, params)
  }
}

export default dadbanFrequentlyAskedQuestionsProvider
